import React from 'react';
import {
  Avatar,
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import instagramIcon from '../../img/socialHandles/instagram.png';
import facebookIcon from '../../img/socialHandles/facebook2.png';
import youtubeIcon from '../../img/socialHandles/youtube.png';

const PLATFORM_META = {
  instagram: { label: 'Instagram', icon: instagramIcon },
  facebook: { label: 'Facebook', icon: facebookIcon },
  youtube: { label: 'YouTube', icon: youtubeIcon },
};

const formatCompactMetric = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return '-';

  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(number);
};

const PlatformBadge = ({ platform }) => {
  const meta = PLATFORM_META[platform] || { label: platform || 'Unknown', icon: instagramIcon };

  return (
    <Box className="influencer-platform-badge">
      <img src={meta.icon} alt={meta.label} className="influencer-platform-icon" />
      <span>{meta.label}</span>
    </Box>
  );
};

const InfluencerTable = ({ rows, loading, onRowClick }) => (
  <TableContainer className="influencer-table-container">
    <Table className="influencer-table">
      <TableHead>
        <TableRow>
          <TableCell>User Handle</TableCell>
          <TableCell>Profile URL</TableCell>
          <TableCell align="right">Followers</TableCell>
          <TableCell align="right">Reach</TableCell>
          <TableCell align="right">Profile Views</TableCell>
          <TableCell align="right">Connected Platform</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {(loading ? new Array(6).fill(null) : rows).map((row, index) => (
          <TableRow
            hover={!loading}
            key={row?.id || row?.handler_id || index}
            className={!loading ? 'influencer-table-row' : ''}
            onClick={!loading ? () => onRowClick(row) : undefined}
          >
            <TableCell>
              {loading ? (
                <Box className="influencer-handle-cell">
                  <Skeleton variant="circular" width={36} height={36} />
                  <Skeleton width={140} />
                </Box>
              ) : (
                <Box className="influencer-handle-cell">
                  <Avatar src={row.avatar} alt={row.handle} className="influencer-handle-avatar">
                    {row.handle?.charAt?.(0)?.toUpperCase() || 'I'}
                  </Avatar>
                  <span className="influencer-handle-text">{row.handle}</span>
                </Box>
              )}
            </TableCell>
            <TableCell>
              {loading ? (
                <Skeleton width={90} />
              ) : row.profileUrl && row.profileUrl !== '-' ? (
                <a
                  href={row.profileUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="influencer-link-chip"
                  onClick={(event) => event.stopPropagation()}
                >
                  <LinkOutlinedIcon fontSize="inherit" />
                  <span>Link</span>
                </a>
              ) : (
                '-'
              )}
            </TableCell>
            <TableCell align="right">
              {loading ? <Skeleton width={60} sx={{ ml: 'auto' }} /> : formatCompactMetric(row.followers)}
            </TableCell>
            <TableCell align="right">
              {loading ? <Skeleton width={50} sx={{ ml: 'auto' }} /> : formatCompactMetric(row.reach)}
            </TableCell>
            <TableCell align="right">
              {loading ? <Skeleton width={50} sx={{ ml: 'auto' }} /> : formatCompactMetric(row.profileViews)}
            </TableCell>
            <TableCell align="right">
              {loading ? (
                <Skeleton width={120} sx={{ ml: 'auto' }} />
              ) : (
                <PlatformBadge platform={row.platform} />
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default InfluencerTable;
